import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useRemoveFollow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollows } from "./useFollows"
import { noticeError } from "src/utils"

export const useDeleteFollow = () => {
  const {
    mutate, data: follows,
  } = useFollows()
  const removeFollow = useRemoveFollow()

  return useMemo(
    () => removeFollow &&
      (async (followId: Follow["id"]) => {
        try {
          const response = await removeFollow(followId)

          if (follows) {
            const updatedList = follows.filter(
              (follow) => follow.id !== followId,
            )
            void mutate(updatedList)
          } else {
            void mutate()
          }

          return response
        } catch (e) {
          noticeError(
            e,
            "DeleteFollow",
            { followId },
          )
          throw e
        }
      }),
    [
      removeFollow,
      follows,
      mutate,
    ],
  )
}
